var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-form",
    {
      ref: "form",
      staticStyle: { width: "100%", "padding-top": "0px" },
      model: {
        value: _vm.formIsValid,
        callback: function ($$v) {
          _vm.formIsValid = $$v
        },
        expression: "formIsValid",
      },
    },
    [
      _c(
        "v-card-text",
        [
          _c("v-text-field", {
            attrs: {
              rules: [_vm.rules.required],
              required: "",
              label: "Alias name",
            },
            model: {
              value: _vm.formObject.synonymName,
              callback: function ($$v) {
                _vm.$set(_vm.formObject, "synonymName", $$v)
              },
              expression: "formObject.synonymName",
            },
          }),
          _vm._v(" "),
          _vm.isDepthHeightDatum
            ? [
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", md8: "" } },
                      [
                        _c("v-autocomplete", {
                          attrs: {
                            items: _vm.datumList,
                            rules: [_vm.rules.required],
                            required: "",
                            "item-text": "DatumName",
                            label: "Select Datum",
                            "return-object": "",
                          },
                          model: {
                            value: _vm.synonymData.targetDatum,
                            callback: function ($$v) {
                              _vm.$set(_vm.synonymData, "targetDatum", $$v)
                            },
                            expression: "synonymData.targetDatum",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", "offset-md1": "", md3: "" } },
                      [
                        _vm.synonymData.targetDatum &&
                        _vm.synonymData.targetDatum.DatumType
                          ? _c("v-text-field", {
                              attrs: { disabled: "", label: "Datum Type" },
                              model: {
                                value:
                                  _vm.synonymData.targetDatum.DatumType.Name,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.synonymData.targetDatum.DatumType,
                                    "Name",
                                    $$v
                                  )
                                },
                                expression:
                                  "synonymData.targetDatum.DatumType.Name",
                              },
                            })
                          : _vm._e(),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "v-layout",
                  { attrs: { row: "", wrap: "" } },
                  [
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md5: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Enter start value in m",
                            type: "number",
                            rules: [
                              _vm.rules.depthHeightRules,
                              _vm.rules.requiredNumber,
                            ],
                          },
                          model: {
                            value: _vm.synonymData.depthHeightStartValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.synonymData,
                                "depthHeightStartValue",
                                _vm._n($$v)
                              )
                            },
                            expression: "synonymData.depthHeightStartValue",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("v-spacer"),
                    _vm._v(" "),
                    _c(
                      "v-flex",
                      { attrs: { xs12: "", sm6: "", md5: "" } },
                      [
                        _c("v-text-field", {
                          attrs: {
                            label: "Enter end value in m",
                            type: "number",
                            rules: [
                              _vm.rules.depthHeightRules,
                              _vm.rules.requiredNumber,
                            ],
                          },
                          model: {
                            value: _vm.synonymData.depthHeightEndValue,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.synonymData,
                                "depthHeightEndValue",
                                _vm._n($$v)
                              )
                            },
                            expression: "synonymData.depthHeightEndValue",
                          },
                        }),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ]
            : _vm._e(),
          _vm._v(" "),
          _vm.isSystemAdmin
            ? [
                _c("v-subheader", { staticClass: "pl-0" }, [
                  _vm._v("System Administrator Settings"),
                ]),
                _vm._v(" "),
                _c("v-checkbox", {
                  staticClass: "mt-0",
                  attrs: {
                    color: "info",
                    label: "Make primary alias",
                    "persistent-hint": "",
                    hint: "The primary alias is the name used in reports",
                  },
                  model: {
                    value: _vm.formObject.isPrimary,
                    callback: function ($$v) {
                      _vm.$set(_vm.formObject, "isPrimary", $$v)
                    },
                    expression: "formObject.isPrimary",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "v-alert",
        {
          key: "alert",
          staticClass: "my-0",
          attrs: {
            outline: "",
            type: "warning",
            value: _vm.formObject.isPrimary,
          },
        },
        [
          _c("div", { staticClass: "primary--text" }, [
            _vm._v(
              "\n      The primary alias name shows up in reports, which may cause confusion if the primary alias does not match the\n      location name.\n    "
            ),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }